// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__38yqz","footer":"ChangeClinic_footer__2kgSn"};